import { useLayoutEffect } from "react";
import NavLink from "@/components/nav/NavLink";
import { toggleOverlay } from "@/utils/sidebar";

const SideBar = () => {
  // Note: This is done this way to avoid having to manage state
  // Refactor this should we implement state management
  useLayoutEffect(() => {
    if (!document.body.attributes["data-init-sidebar"]) {
      if (localStorage?.getItem("data-toggled") === "icon-overlay-open") {
        document.body.setAttribute("data-toggled", "icon-overlay-open");
        document.body.setAttribute("data-init-sidebar", "true");
      } else {
        document.body.setAttribute("data-toggled", "icon-overlay-close");
      }
    }
  }, []);

  return (
    <div
      className="app-sidebar sticky"
      id="sidebar"
      onMouseEnter={() => toggleOverlay(true)}
      onMouseLeave={() => toggleOverlay(false)}
    >
      <div className="main-sidebar-header">
        <a href="/" className="header-logo">
          <img alt="logo" height="100%" src={"/logo-icon-only.png"} />
        </a>
      </div>

      <div className="main-sidebar" id="sidebar-scroll">
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <ul className="main-menu">
            <li className="slide mb-1">
              <NavLink
                href="/reports/livewire"
                exact
                className="side-menu__item"
              >
                <>
                  <i className="bi bi-bar-chart-steps fs-16 " />
                  <span className="ms-3 side-menu__label">Livewire</span>
                </>
              </NavLink>
            </li>

            {/* <li className="slide__category  mb-1">
              <span className="category-name">Analyst</span>
            </li> */}

            {/* <li className="slide mb-1">
              <NavLink href="/" exact className="side-menu__item">
                <>
                  <i className="bi bi-bar-chart fs-16 " />
                  <span className="ms-3 side-menu__label">Dashboard</span>
                </>
              </NavLink>
            </li> */}

            {/* <li className="slide  mb-1">
              <NavLink href="/applications" className="side-menu__item">
                <>
                  <i className="bi bi-person-vcard fs-16" />
                  <span className="ms-3 side-menu__label">Applicants</span>
                </>
              </NavLink>
            </li> */}
            {/* <li className="slide  mb-1">
              <NavLink href="/archive" className="side-menu__item">
                <>
                  <i className="bi bi-archive fs-16" />
                  <span className="ms-3 side-menu__label">Archives</span>
                </>
              </NavLink>
            </li> */}
            {/* <li className="slide__category  mb-1">
              <span className="category-name">External</span>
            </li>
            <li className="slide mb-1">
              <NavLink href="/dashboard" exact className="side-menu__item">
                <>
                  <i className="bi bi-speedometer fs-16 " />
                  <span className="ms-3 side-menu__label">Dashboard</span>
                </>
              </NavLink>
            </li>
            <li className="slide  mb-1">
              <NavLink href="/screenings" className="side-menu__item">
                <>
                  <i className="bi bi-file-person fs-16" />
                  <span className="ms-3 side-menu__label">Screenings</span>
                </>
              </NavLink>
            </li>
            <li className="slide  mb-1">
              <NavLink href="/reports" className="side-menu__item">
                <>
                  <i className="bi bi-bar-chart fs-16" />
                  <span className="ms-3 side-menu__label">Reports</span>
                </>
              </NavLink>
            </li> */}
            {/* <li className="slide  mb-1">
              <a href="/reports" className="side-menu__item">
                <i className="bi bi-bar-chart fs-16 " />
                <span className="ms-3 side-menu__label">Reports</span>
              </a>
            </li> */}
            {/* <li className="slide  mb-1">
              <a href="/settings" className="side-menu__item">
                <i className="bi bi-gear fs-16 " />
                <span className="ms-3 side-menu__label">Settings</span>
              </a>
            </li> */}
            {/* <li className="slide__category  mb-1">
              <span className="category-name">Account</span>
            </li> */}
            {/* <li className="slide">
              <a href="logout" className="side-menu__item">
                <i className="bi bi-box-arrow-right fs-16 " />
                <span className="ms-3 side-menu__label">Logout</span>
              </a>
            </li> */}
          </ul>
        </nav>
      </div>
    </div>
  );
};

SideBar.propTypes = {};

export default SideBar;
